export default "__VITE_ASSET__73aea64f__$_?component__"